<script setup lang="ts">
import type { MediaSummary, PlaybackRecord } from '../../../shared/contracts'
import { computed } from 'vue'
import MediaCard from './MediaCard.vue'

const props = defineProps<{ items: MediaSummary[], records?: PlaybackRecord[], removable?: boolean, from?: string, showPlaybackStatus?: boolean, directPlayback?: boolean }>()
const emit = defineEmits<{ remove: [media: MediaSummary] }>()
const recordsByKey = computed(() => new Map(props.records?.map(record => [record.key, record]) || []))

function recordFor(media: MediaSummary) {
    return recordsByKey.value.get(`${media.sourceId}:${media.id}`)
}
</script>

<template>
    <div class="grid grid-cols-3 gap-x-3 gap-y-7 lg:grid-cols-5 md:grid-cols-4 xl:grid-cols-6 sm:gap-x-5 sm:gap-y-9">
        <MediaCard v-for="(item, index) in items" :key="`${item.sourceId}:${item.id}`" :media="item" :record="recordFor(item)" :removable="removable" :from="from" :show-playback-status="showPlaybackStatus" :direct-playback="directPlayback" :class="index < 12 && 'reveal-up'" :style="index < 12 ? { animationDelay: `${index * 35}ms` } : undefined" @remove="emit('remove', item)" />
    </div>
</template>
